import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  @Input() public type = 'info';

  public alertClass = '';

  constructor() {}

  public ngOnInit(): void {
    switch (this.type) {
      case 'success':
        this.alertClass = 'green-div';
        break;
      case 'warning':
        this.alertClass = 'yellow-div';
        break;
      case 'error':
        this.alertClass = 'red-div';
        break;
      case 'display':
        this.alertClass = 'beige-div';
        break;
      case 'workflow':
        this.alertClass = 'grey-div';
        break;
      default:
        this.alertClass = 'blue-div';
        break;
    }
  }
}
